import { Formik, Form } from 'formik';
import ReactGA from 'react-ga4';
import { motion } from 'framer-motion';

import Modal from '../../../Modal/Modal';
import { useAssessmentContext } from '../../../../providers';
import { TextareaField } from '../../../InputComponents';

function AnythingElse() {
    const { finishAssessment, setAnswer } = useAssessmentContext();

    return (
        <motion.div
            key="anything-else-question"
            initial={{ opacity: 0, translateX: '20%' }}
            animate={{ opacity: 1, translateX: 0 }}
            exit={{ opacity: 0, translateX: '-20%' }}>
            <Modal
                showClose={true}
                isOpen={true}
                closeHandler={() => {
                    setAnswer({ answer: '', answerKey: 'anythingElse' });
                    finishAssessment();
                }}>
                <h2 className="mb-2 font-heading text-3xl text-gray-darker lg:mb-4 lg:text-5xl">
                    Is there anything else you would like us to know?
                </h2>
                <Formik
                    initialValues={{ anythingElse: '' }}
                    onSubmit={(data) => {
                        if (data.anythingElse.length > 0) {
                            ReactGA.event({
                                category: 'User',
                                action: 'Answered a Question',
                                label: 'anythingelse_fill',
                            });
                        } else {
                            ReactGA.event({
                                category: 'User',
                                action: 'Answered a Question',
                                label: 'anythingelse_proceed',
                            });
                        }

                        setAnswer({ answer: data.anythingElse, answerKey: 'anythingElse' });

                        //Finish the assessment
                        finishAssessment();
                    }}>
                    <Form>
                        <TextareaField
                            name="anythingElse"
                            id="anythingElse"
                            className="mb-8 h-40 w-full border border-gray-darker p-5 lg:mb-12 lg:px-6"
                            placeholder="Optional."
                        />
                        <button className="btn-primary w-full" type="submit">
                            Finish
                        </button>
                    </Form>
                </Formik>
            </Modal>
        </motion.div>
    );
}

export default AnythingElse;
